import type { ElevationReferenceFrame } from "building-types/views/elevationReferenceFrame";

export const elevationReferenceFrames: {
  [key in ElevationReferenceFrame]: key;
} = {
  FRONT: "FRONT",
  BACK: "BACK",
  LEFT: "LEFT",
  RIGHT: "RIGHT",
} as const;
